import { ApolloProvider as ApolloProviderBase } from '@apollo/client';
import { PropsWithChildren, useMemo } from 'react';
import type { RuntimeNetworkOptions } from '@models/widgets';
import client, { createClient } from './config';

interface ApolloProviderProps {
    network?: RuntimeNetworkOptions;
}

function ApolloProvider({ children, network }: PropsWithChildren<ApolloProviderProps>) {
    const apolloClient = useMemo(() => {
        if (!network?.apiOrigin) {
            return client;
        }

        return createClient({ apiOrigin: network.apiOrigin });
    }, [network?.apiOrigin]);

    return <ApolloProviderBase client={apolloClient}>{children}</ApolloProviderBase>;
}

export default ApolloProvider;
